// Monetisation → Ads (contracts/ads.md §5). The ads.* settings go through GET/PUT /config (useConfig,
// useSetConfig); this adds the stats. Kept apart from client.ts / queries.ts like the Studio.

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { request } from "./client";
import { AdsStats } from "./adsSchemas";

export const adsApi = {
  /** UTC days, `to` inclusive (default: the last 30 days). */
  stats: (from: string, to: string, signal?: AbortSignal) => request(AdsStats, "GET", "/ads/stats", { query: { from, to }, signal }),
};

export const adsKeys = { stats: (from: string, to: string) => ["ads", "stats", from, to] as const };

export const useAdsStats = (from: string, to: string) =>
  useQuery({ queryKey: adsKeys.stats(from, to), queryFn: ({ signal }) => adsApi.stats(from, to, signal), placeholderData: keepPreviousData });
